import { getContent } from "../../utilities/get-content";
export function getUnitJson(unitId, curriculumConfig) {
    const unitSpec = curriculumConfig.getUnitSpec(unitId);
    const unitUrl = unitSpec === null || unitSpec === void 0 ? void 0 : unitSpec.content;
    return fetchJson(unitUrl);
}
export function getGuideJson(unitId, curriculumConfig) {
    const unitSpec = curriculumConfig.getUnitSpec(unitId);
    const guideUrl = unitSpec === null || unitSpec === void 0 ? void 0 : unitSpec.guide;
    return fetchJson(guideUrl);
}
function fetchJson(url) {
    return getContent(url)
        .then((response) => {
        if (response.ok) {
            return response.json();
        }
        else {
            // If the unit content is not found, return the response so that the caller can
            // handle it appropriately.
            if (response.status === 404) {
                return response;
            }
            else {
                throw Error(`Request rejected with status ${response.status}`);
            }
        }
    })
        .catch(error => {
        throw Error(`Failed to load content ${url} cause:\n ${error}`);
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidW5pdC11dGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9tb2RlbHMvY3VycmljdWx1bS91bml0LXV0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxVQUFVLEVBQUUsTUFBTSw2QkFBNkIsQ0FBQztBQUd6RCxNQUFNLFVBQVUsV0FBVyxDQUFDLE1BQTBCLEVBQUUsZ0JBQW1DO0lBQ3pGLE1BQU0sUUFBUSxHQUFHLGdCQUFnQixDQUFDLFdBQVcsQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUN0RCxNQUFNLE9BQU8sR0FBRyxRQUFRLGFBQVIsUUFBUSx1QkFBUixRQUFRLENBQUUsT0FBTyxDQUFDO0lBQ2xDLE9BQU8sU0FBUyxDQUFDLE9BQVEsQ0FBQyxDQUFDO0FBQzdCLENBQUM7QUFFRCxNQUFNLFVBQVUsWUFBWSxDQUFDLE1BQTBCLEVBQUUsZ0JBQW1DO0lBQzFGLE1BQU0sUUFBUSxHQUFHLGdCQUFnQixDQUFDLFdBQVcsQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUN0RCxNQUFNLFFBQVEsR0FBRyxRQUFRLGFBQVIsUUFBUSx1QkFBUixRQUFRLENBQUUsS0FBSyxDQUFDO0lBQ2pDLE9BQU8sU0FBUyxDQUFDLFFBQVMsQ0FBQyxDQUFDO0FBQzlCLENBQUM7QUFFRCxTQUFTLFNBQVMsQ0FBQyxHQUFXO0lBQzVCLE9BQU8sVUFBVSxDQUFDLEdBQUcsQ0FBQztTQUNuQixJQUFJLENBQUMsQ0FBQyxRQUFRLEVBQUUsRUFBRTtRQUNqQixJQUFJLFFBQVEsQ0FBQyxFQUFFLEVBQUUsQ0FBQztZQUNoQixPQUFPLFFBQVEsQ0FBQyxJQUFJLEVBQUUsQ0FBQztRQUN6QixDQUFDO2FBQU0sQ0FBQztZQUNOLCtFQUErRTtZQUMvRSwyQkFBMkI7WUFDM0IsSUFBSSxRQUFRLENBQUMsTUFBTSxLQUFLLEdBQUcsRUFBRSxDQUFDO2dCQUM1QixPQUFPLFFBQVEsQ0FBQztZQUNsQixDQUFDO2lCQUFNLENBQUM7Z0JBQ04sTUFBTSxLQUFLLENBQUMsZ0NBQWdDLFFBQVEsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxDQUFDO1lBQ2pFLENBQUM7UUFDSCxDQUFDO0lBQ0gsQ0FBQyxDQUFDO1NBQ0QsS0FBSyxDQUFDLEtBQUssQ0FBQyxFQUFFO1FBQ2IsTUFBTSxLQUFLLENBQUMsMEJBQTBCLEdBQUcsYUFBYSxLQUFLLEVBQUUsQ0FBQyxDQUFDO0lBQ2pFLENBQUMsQ0FBQyxDQUFDO0FBQ1AsQ0FBQyJ9